import { cn } from "@coval/ui"

interface NotebookTableProps {
  columns: string[]
  rows: Record<string, unknown>[]
}

function formatCell(value: unknown): string {
  if (value === null || value === undefined) {
    return ""
  }
  if (typeof value === "number") {
    return Number.isInteger(value) ? String(value) : value.toFixed(2)
  }
  if (typeof value === "string" || typeof value === "boolean") {
    return String(value)
  }
  return JSON.stringify(value)
}

/** Bounded result preview. Rows come from Sofia's chart payload or its answer, never a raw result set. */
export function NotebookTable({ columns, rows }: NotebookTableProps) {
  return (
    <div className="overflow-x-auto rounded-md border border-coval-border">
      <table className="w-full text-sm">
        <thead className="bg-surface-1 text-left text-xs uppercase tracking-wide text-coval-text-muted">
          <tr>
            {columns.map((column) => (
              <th key={column} className="px-3 py-2 font-medium">
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className={cn(
                "border-t border-coval-border",
                rowIndex % 2 === 1 && "bg-surface-1/40",
              )}
            >
              {columns.map((column) => {
                const value = row[column]
                return (
                  <td
                    key={column}
                    className={cn(
                      "px-3 py-1.5 text-coval-text",
                      typeof value === "number" && "tabular-nums text-right",
                    )}
                  >
                    {formatCell(value)}
                  </td>
                )
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
